<template>

    <Head :title="title"></Head>

    <div class="h-screen w-screen flex bg-grey">

        <Banner />

        <div class="h-screen bg-dark-blue flex flex-col overflow-y-scroll overflow-x-hidden"
            style="width: var(--sidebar-width);">


            <div class="w-full flex justify-center p-8">

                <Logo class="w-full"
                    src="/images/logo-white.png"
                    :href="route('dashboard')"
                />

            </div>


            <nav class="w-full flex flex-col relative py-4">

                <NavLink class="mb-3"
                    :href="route('dashboard')">{{ __('Dashboard') }}</NavLink>


                <p class="text-light-blue px-6 text-sm">{{ __('Newsletter') }}</p>

                <NavLink class=""
                         :href="route('campaign_rules')">{{ __('Campaigns') }}</NavLink>

                <NavLink class=""
                         :href="route('ads')">{{ __('Ads') }}</NavLink>

                <NavLink class=""
                         :href="route('topics')">{{ __('Topics') }}</NavLink>

                <NavLink class="mb-5"
                         :href="route('languages')">{{ __('Languages') }}</NavLink>


                <p class="text-light-blue px-6 text-sm">{{ __('Content') }}</p>

                <NavLink class=""
                         :href="route('news')">{{ 'News' }}</NavLink>

                <NavLink class=""
                         :href="route('events')">{{ 'Calendar' }}</NavLink>

                <NavLink class=""
                         :href="route('fundings')">{{ 'Funding' }}</NavLink>

                <NavLink class="mb-4"
                         :href="route('publications')">{{ 'Publications' }}</NavLink>


                <NavLink class=""
                    :href="route('profile.show')">

                    <font-awesome-icon :icon="['far', 'user']" class="mr-2" /> {{ __('User') }}

                </NavLink>


                <form @submit.prevent="logout" class="w-full">


                    <NavLink class=""
                        as="button">


                        <font-awesome-icon :icon="['far', 'power-off']" class="mr-2 text-red" />

                        {{ __('Log out') }}

                    </NavLink>


                </form>


            </nav>


            <div class="mt-auto mx-auto flex flex-row items-center">

                <toggle-button></toggle-button>

            </div>


            <div class="mt-3">

                <div class="p-3 text-white flex flex-wrap
                border-darker-blue
                text-sm font-bold  justify-center">


                    <div class="my-auto rounded-full h-[12px] w-[12px]"
                         :class=" {
                        'bg-green': importer_status_text === 'Importer Running',
                        'bg-red-500': importer_status_text === 'Importer Stopped'}">

                    </div>


                    <span class="ml-2 text-[13px] my-auto">

                        {{ importer_status_text }}

                    </span>


                    <div class="text-xs">

                        <span>

                            {{ importer_status_latest }}

                        </span>

                    </div>


                </div>


            </div>


            <Version class=""></Version>

        </div>


        <div class="h-screen overflow-x-hidden overflow-y-scroll"
            style="width: calc(100vw - var(--sidebar-width));">


            <main class="h-full"
                style="max-width: 1700px;width:100%;margin-left: auto;margin-right:auto;">


                <slot></slot>


            </main>


        </div>


    </div>


</template>


<script>

    import { defineComponent } from 'vue';
    import Banner from '../Components/Banner.vue';
    import Dropdown from '../Components/Dropdown.vue';
    import DropdownLink from '../Components/DropdownLink.vue';
    import NavLnk from '../Components/NavLink.vue';
    import ResponsiveNavLink from '../Components/ResponsiveNavLink.vue';
    import Link from '../Components/Link.vue';
    import { Head } from '@inertiajs/inertia-vue3';
    import NavLink from "../Components/NavLink.vue";
    import Version from "../Components/Version";
    import Logo from "../Components/Logo";
    import ToggleButton from "../Components/ToggleButton";

    export default defineComponent({

        props: {
            title: String,
        },

        components: {
            ToggleButton,
            Logo,
            Version,
            NavLink,
            Head,
            Banner,
            Dropdown,
            DropdownLink,
            NavLnk,
            ResponsiveNavLink,
            Link
        },


        data() {
            return {
            }
        },


        mounted() {

        },

        computed: {

            importer_status_text() {
                if (this.$page.props.importer.running) {
                    return 'Importer Running';
                }
                return 'Importer Stopped';
            },

            importer_status_latest() {
                return this.$page.props.importer.latest;
            }

        },


        methods: {

            logout() {
                this.$inertia.post( this.route('logout') );
            },

        },
    })

</script>

<style>

:root {
    --sidebar-width: 170px;
}

</style>
